import {
  selectUser,
  useUserSelector,
} from '@sceneio/content-store/lib/features/user/userSlice'
import { useEffect } from 'react'

export function useFeaturebaseWidgetScript() {
  const { email } = useUserSelector(selectUser)

  useEffect(() => {
    const script = document.createElement('script')

    script.src = 'https://do.featurebase.app/js/sdk.js'
    script.id = 'featurebase-sdk'

    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [])

  useEffect(() => {
    const win = window as any

    if (typeof win.Featurebase !== 'function') {
      win.Featurebase = function () {
        // eslint-disable-next-line prefer-rest-params
        ;(win.Featurebase.q = win.Featurebase.q || []).push(arguments)
      }
    }

    win.Featurebase('initialize_feedback_widget', {
      organization: 'sceneio',
      theme: 'light',
      email,
      metadata: null,
    })
  }, [email])
}
